import { useMutation } from "@tanstack/react-query"
import { forgotPassword, resetPassword } from "@/lib/api/forgot-password.api"

export function useForgotPassword() {
  return useMutation({
    mutationFn: (email: string) => forgotPassword(email),
  })
}

export function useResetPassword() {
  return useMutation({
    mutationFn: (payload: { email: string; otp: string; newPassword: string }) =>
      resetPassword(payload),
  })
}
